export default {
  'pages.layouts.userLayout.title': 'Hi~',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.workbench.link': 'workbench',
  'pages.workbench.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, workbench to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.announcement.status.draft': 'Draft',
  'pages.announcement.status.scheduled': 'Scheduled',
  'pages.announcement.status.publishing': 'Publishing',
  'pages.announcement.status.published': 'Published',
  'pages.announcement.status.publish_failed': 'Publish Failed',
  'pages.announcement.status.revoked': 'Revoked',
  'pages.announcement.audience.memberLabel': 'Selected Members',
  'pages.announcement.audience.selectMembers': 'Please select members',
  'pages.announcement.fields.status': 'Status',
  'pages.announcement.fields.publishTime': 'Publish Time',
  'pages.announcement.fields.audience': 'Audience',
  'pages.announcement.fields.summary': 'Summary',
  'pages.announcement.fields.revokeReason': 'Revoke Reason',
  'pages.announcement.fields.content': 'Content',
  'pages.announcement.fields.attachments': 'Attachments',
  'pages.announcement.admin.title': 'Announcements',
  'pages.announcement.admin.columns.title': 'Title',
  'pages.announcement.admin.columns.creator': 'Creator',
  'pages.announcement.admin.columns.publishTimeRange': 'Publish Time Range',
  'pages.announcement.admin.columns.actions': 'Actions',
  'pages.announcement.admin.search.titlePlaceholder': 'Enter title keyword',
  'pages.announcement.admin.search.creatorPlaceholder': 'Enter creator',
  'pages.announcement.admin.pendingPublish': 'Pending',
  'pages.announcement.admin.revokeReason': 'Revoked manually from admin page',
  'pages.announcement.admin.empty':
    'No announcements yet. Create your first announcement from the top right.',
  'pages.announcement.admin.dispatchModalTitleWithName':
    'Dispatch Records for {title}',
  'pages.announcement.detail.title': 'Announcement Detail',
  'pages.announcement.detail.notFound': 'Announcement not found',
  'pages.announcement.detail.backToList': 'Back to List',
  'pages.announcement.detail.edit': 'Edit',
  'pages.announcement.detail.revoke': 'Revoke',
  'pages.announcement.detail.revokeReason': 'Revoked manually from detail page',
  'pages.announcement.detail.revokeSuccess': 'Announcement revoked',
  'pages.announcement.detail.dispatchRecords': 'Dispatch Records',
  'pages.announcement.create.title': 'Create Announcement',
  'pages.announcement.create.scheduleSuccess':
    'Announcement scheduled successfully',
  'pages.announcement.create.publishSuccess':
    'Announcement submitted for publishing',
  'pages.announcement.edit.title': 'Edit Announcement',
  'pages.announcement.edit.updateSuccess': 'Announcement updated',
  'pages.announcement.form.statusReason': 'This announcement has a status note',
  'pages.announcement.form.title': 'Title',
  'pages.announcement.form.titlePlaceholder': 'Please enter title',
  'pages.announcement.form.titleRequired': 'Please enter title',
  'pages.announcement.form.summary': 'Summary',
  'pages.announcement.form.summaryPlaceholder':
    'Please enter summary. The card will prefer showing the summary.',
  'pages.announcement.form.content': 'Content',
  'pages.announcement.form.contentPlaceholder': 'Please enter content',
  'pages.announcement.form.contentRequired': 'Please enter content',
  'pages.announcement.form.pinned': 'Pin Display',
  'pages.announcement.form.pinnedOn': 'Pinned',
  'pages.announcement.form.pinnedOff': 'Normal',
  'pages.announcement.form.publishMode': 'Publish Time',
  'pages.announcement.form.publishModeRequired': 'Please select publish type',
  'pages.announcement.form.scheduledAt': 'Scheduled Publish Time',
  'pages.announcement.form.scheduledAtRequired':
    'Please select scheduled publish time',
  'pages.announcement.form.scheduledAtFuture':
    'Scheduled publish time must be later than the current time',
  'pages.announcement.form.audiences': 'Audience',
  'pages.announcement.form.audiencesRequired':
    'Please add at least one audience',
  'pages.announcement.form.memberRequired': 'Please select members',
  'pages.announcement.form.saveDraft': 'Save Draft',
  'pages.announcement.form.saveDraftSuccess': 'Draft saved',
  'pages.announcement.form.publishScheduled': 'Schedule Publish',
  'pages.announcement.form.publishNow': 'Publish Now',
  'pages.announcement.form.submitTip':
    'Saving draft will not trigger the message center. Immediate and scheduled publish both follow backend rules.',
  'pages.announcement.form.cancel': 'Cancel',
  'pages.announcement.center.title': 'Announcement Center',
  'pages.announcement.center.columns.title': 'Title',
  'pages.announcement.center.columns.readStatus': 'Read Status',
  'pages.announcement.center.columns.pinned': 'Pinned',
  'pages.announcement.center.columns.organization': 'Organization',
  'pages.announcement.center.columns.attachmentStatus': 'Attachment Status',
  'pages.announcement.center.search.titlePlaceholder': 'Enter title keyword',
  'pages.announcement.center.read.read': 'Read',
  'pages.announcement.center.read.unread': 'Unread',
  'pages.announcement.center.boolean.yes': 'Yes',
  'pages.announcement.center.boolean.no': 'No',
  'pages.announcement.center.boolean.none': 'None',
  'pages.announcement.center.attachment.has': 'With Attachments',
  'pages.announcement.center.attachment.none': 'No Attachments',
  'pages.announcement.center.emptySummary': 'No summary',
  'pages.announcement.center.viewDetail': 'View Detail',
  'pages.announcement.center.empty': 'No announcements available',
  'pages.announcement.center.detail.title': 'Announcement Detail',
  'pages.announcement.center.detail.backToCenter': 'Back to Center',
  'pages.announcement.center.detail.content': 'Content',
  'pages.announcement.center.detail.loadFailed': 'Failed to load announcement',
  'pages.announcement.center.detail.retry': 'Retry',
  'pages.announcement.permission.queryRequired':
    'The current account does not have query permission',
  'pages.announcement.dispatch.columns.type': 'Dispatch Type',
  'pages.announcement.dispatch.columns.status': 'Message Center Status',
  'pages.announcement.dispatch.columns.errorMessage': 'Failure Reason',
  'pages.announcement.dispatch.columns.response': 'Response Summary',
  'pages.announcement.dispatch.status.pending': 'Pending',
  'pages.announcement.dispatch.status.processing': 'Processing',
  'pages.announcement.dispatch.status.success': 'Success',
  'pages.announcement.dispatch.status.failed': 'Failed',
  'pages.announcement.dispatch.malformedResponse':
    'Historical response summary format is invalid',
  'pages.announcement.dispatch.expand': 'Expand',
  'pages.announcement.attachment.uploadSuccess': '{name} uploaded successfully',
  'pages.announcement.attachment.uploadFailed':
    'Attachment upload failed. Please try again.',
  'pages.announcement.attachment.fileTooLarge':
    'A single attachment cannot exceed 20MB',
  'pages.announcement.attachment.selectFiles': 'Select attachments',
  'pages.announcement.attachment.empty': 'No attachments',
  'pages.announcement.attachment.delete': 'Delete',
  'pages.announcement.attachment.retry': 'Retry',
  'pages.announcement.attachment.uploadCompleted': 'Upload completed',
  'pages.announcement.attachment.missingFileKey':
    'The attachment is missing a file identifier and cannot be downloaded for now',
  'pages.announcement.attachment.downloadUrlMissing':
    'The backend did not return a download URL',
  'pages.announcement.attachment.downloadFailed': 'Failed to get download URL',
  'pages.announcement.attachment.download': 'Download',
};
